import React from "react";
import styles from "./layout-background-loader-scss.js";
const DEFAULT_BACKGROUND_COLOR = "#f5f5f5";
const LayoutBackgroundLoader = ({
  backgroundColor = DEFAULT_BACKGROUND_COLOR
}) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles.overlay,
      style: { "--shimmer-base-color": backgroundColor }
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.shimmer })
  );
};
export {
  LayoutBackgroundLoader
};
//# sourceMappingURL=layout-background-loader.js.map
